//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import Global from '../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import M_RNM_BASIC from './M_RNM_BASIC';
import { useSearch1, useDelete1 } from './M_RNM_BASIC_Query';
import { useDelete } from '../../../Hooks/useDelete';
//#endregion

function M_RNM_BASICF() {
  //#region 변수
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const dispatch = useDispatch();
  const searchInfo = useSelector((state) => state.searchInfo) ?? {};
  const depListFromRedux = searchInfo.depList ?? [];
  const depList = [{ value: '', name: '전체' }, ...depListFromRedux];
  const gongjongListFromRedux = searchInfo.gongjongList ?? [];
  const gongjongList = [{ value: '', name: '전체' }, ...gongjongListFromRedux];
  const depName =
    depList.find((d) => (d.value ?? '') === (searchInfo.depCd ?? ''))?.name ??
    '전체';
  const gongjongNm =
    gongjongList.find((g) => (g.value ?? '') === (searchInfo.gongjongCd ?? ''))
      ?.name ?? '전체';
  const [workinfoData, setWorkinfoData] = useState([]);
  const [selectedWorkInfo, setSelectedWorkInfo] = useState(null);

  //#endregion

  useEffect(() => {
    Init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Init = async () => {
    try {
      dispatch(NavBarInfoActions.setType('titleBar'));
      dispatch(NavBarInfoActions.setTitleName('위험성평가하기'));
      SearchLogic1();
    } catch (e) {
      console.error('Init Error:', e);
    }
  };

  //#region 쿼리
  const { runAsync: Search1Async } = useSearch1({
    onSuccess: (rows) => {
      const converted = (rows || []).map((item) => ({
        ...item,
        firstImageUrl: item.images.length
          ? `${Global.file.useUrl}files/${item.images[0].imageFilePath.replace(/\\/g, '/')}`
          : '',
      }));
      setWorkinfoData(converted);
    },
  });

  const { runAsync: Delete1Async } = useDelete1();

  const { run: Delete1 } = useDelete({
    menuId: 'M_RNM_BASIC',
    requestDelete: (rows) => Delete1Async({ nearMissSeq: rows[0] }),
    onSuccess: () => {
      SearchLogic1();
    },
  });

  const SearchLogic1 = (override = {}) => {
    Search1Async({
      userInfo,
      depCd: override.depCd ?? searchInfo.depCd ?? '',
      gongjongCd: override.gongjongCd ?? searchInfo.gongjongCd ?? '',
      year: override.year ?? searchInfo.year ?? '',
      month: override.month ?? searchInfo.month ?? '',
    });
  };
  //#endregion

  return (
    <div className="wrap">
      <M_RNM_BASIC
        userInfo={userInfo}
        workinfoData={workinfoData}
        setSelectedWorkInfo={setSelectedWorkInfo}
        selectedWorkInfo={selectedWorkInfo}
        SearchLogic1={SearchLogic1}
        DeleteLogic1={Delete1}
        filterState={{
          depName: depName,
          gongjongNm: gongjongNm,
          year: searchInfo.year ?? '',
          month: searchInfo.month ?? '',
        }}
        depList={depList}
        gongjongList={gongjongList}
      />
    </div>
  );
}

export default M_RNM_BASICF;
